import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import ProtectedRoute from './components/ProtectedRoute';

const Login = lazy(() => import('./pages/Login'));
const Register = lazy(() => import('./pages/Register'));
const Dashboard = lazy(() => import('./pages/Dashboard'));
const OnboardingAgenda = lazy(() => import('./pages/OnboardingAgenda'));
const Customers = lazy(() => import('./pages/Customers'));
const BotConfig = lazy(() => import('./pages/BotConfig'));
const AppointmentsCalendar = lazy(() => import('./pages/AppointmentsCalendar'));
const ConnectWhatsapp = lazy(() => import('./pages/ConnectWhatsapp'));
const Conversaciones = lazy(() => import('./pages/Conversaciones'));
const AdminBusinesses = lazy(() => import('./pages/AdminBusinesses'));
const BillingPlans = lazy(() => import('./pages/BillingPlans'));
const Privacidad = lazy(() => import('./pages/Privacidad'));
const Terminos = lazy(() => import('./pages/Terminos'));
const EliminarDatos = lazy(() => import('./pages/EliminarDatos'));

function PageFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center text-gray-400 text-sm">
      Cargando...
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<PageFallback />}>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/onboarding"
          element={
            <ProtectedRoute>
              <OnboardingAgenda />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/clientas"
          element={
            <ProtectedRoute>
              <Customers />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/configuracion"
          element={
            <ProtectedRoute>
              <BotConfig />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/citas"
          element={
            <ProtectedRoute>
              <AppointmentsCalendar />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/conversaciones"
          element={
            <ProtectedRoute>
              <Conversaciones />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/whatsapp"
          element={
            <ProtectedRoute>
              <ConnectWhatsapp />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminBusinesses />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard/facturacion"
          element={
            <ProtectedRoute>
              <BillingPlans />
            </ProtectedRoute>
          }
        />
        <Route path="/privacidad" element={<Privacidad />} />
        <Route path="/terminos" element={<Terminos />} />
        <Route path="/eliminar-datos" element={<EliminarDatos />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
